﻿window.cObjetCompteEmailUtilisateurMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "compte email"; }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouveau compte email"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') { txt = this.mGetCompteEmail().adresse_email }
        else {
            txt = "adresse email"
        }
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-square-envelope'></i>");
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
    }

    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();

    }

    this.mShowPopup = function (optionPopup) {
        if (typeof optionPopup == 'undefined' || optionPopup == null) optionPopup = {}
    }

    this.mGetCompteEmail = function () {
        return Me.objet.bddRef.mGetArray("compte_email").filter(function (o) { return o.id_compte_email == objet.data.id_compte_email })[0]
    }

    //retourne si le compteemailutilisateur est seul
    this.isUnique = function () {
        return (Me.objet.bddRef.mGetArray("compte_email_utilisateur").filter(function (o) { return o.id_utilisateur == objet.data.id_utilisateur && o.id_compte_email_utilisateur != objet.data.id_compte_email_utilisateur }).length == 0)
    }

    this.mSaveBeforeBloquant = function (funcOk, nomChamp) {
        if ((typeof nomChamp == "undefined" || nomChamp == "defaut") && objet.data.defaut == "1") {
            //on est sur l'adresse eamil par défaut
            //on vérifie que l'on a pas une autre adresse email par défaut
            //si c'est le cas, on enlève le par défaut
            var lstCompteEmailUtilisateur = Me.objet.bddRef.mGetArray("compte_email_utilisateur").filter(function (o) { return o.id_utilisateur == objet.data.id_utilisateur && o.defaut == "1" && o.id_compte_email_utilisateur!=objet.data.id_compte_email_utilisateur })

            if (lstCompteEmailUtilisateur.length > 0) {
                function mSaveDefaut(idx) {
                    var dataCompteEmailUti = lstCompteEmailUtilisateur[idx]
                    if (typeof dataCompteEmailUti == 'undefined') { funcOk() }
                    else {
                        dataCompteEmailUti.defaut = "0"
                        Me.objet.bddRef.getObjet(dataCompteEmailUti).mSaveChamp("defaut", function () {
                            idx += 1
                            mSaveDefaut(idx)
                        })
                    }
                }
                mSaveDefaut(0)
            } else { funcOk() }
        } else { funcOk()}
    }

}